import React from "react";

const IslamicCentre = () => {
  // Additional images for Islamic Research Centre
  const additionalImages = [
    "/images/Picture57.jpg",
    "/images/Picture13.jpg",
    "/images/Picture46.jpg",
  ];

  return (
    <div className="w-[90%] mx-auto py-12 flex flex-col gap-12">
      {/* Top Section: Text and Main Image */}
      <div className="flex flex-col lg:flex-row items-start gap-8">
        {/* Left Text Section */}
        <div className="lg:w-2/3 space-y-6">
          <h2 className="text-3xl font-bold text-gray-800">Islamic Research Centre, Lahore</h2>
          <h3 className="text-2xl font-bold text-gray-800 leading-tight">
            Construction Services by PACIFIC BUILDERS (PVT) LTD
          </h3>
          <p className="text-gray-700">
            <strong>Islamic Research Centre</strong> is a large complex located on Hali Road, Lahore. The project includes the construction of a modern research facility and the integration and extension of the existing mosque, combining both functionality and spiritual aesthetics.
          </p>

          <div className="text-lg text-gray-700">
            <p><strong>Scope of Work:</strong> Civil works</p>
            <p><strong>Architect:</strong> Nayyer Ali Dada</p>
            <p><strong>Covered Area:</strong> 80,000 sq ft</p>
            <p><strong>Location:</strong> Hali Road, Gulberg, Lahore</p>
            <p><strong>Client:</strong> Anjuman-e-Mohammadi</p>
            <p><strong>Status:</strong> Complete</p>
          </div>
        </div>

        {/* Right Image Section */}
        <div className="lg:w-1/3">
          <img
            src="/images/Picture58.jpg"
            alt="Islamic Research Centre Construction"
            className="w-full h-auto rounded shadow"
          />
        </div>
      </div>

      {/* Additional Images Section */}
      {additionalImages.length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {additionalImages.map((img, index) => (
            <img
              key={index}
              src={img}
              alt={`Islamic Research Centre ${index + 1}`}
              className="w-full h-[200px] rounded shadow"
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default IslamicCentre;
